import React from 'react';
import '../../styles/global.css';

const CustomLayout = ({ children }) => {
  return <>{children}</>;
};

export default CustomLayout;
